import React, { useState } from "react";
import { SectionRule } from "components/common/SectionRule";
import { LoadingState } from "components/common/LoadingState";
import { GovernanceAuditList } from "@/components/main/governance/GovernanceAuditList";
import { GovernanceAuditPanel } from "@/components/main/governance/GovernanceAuditPanel";
import { useGovernanceAudit } from "@/components/main/governance/useGovernanceAudit";
import type { Org } from "@/lib/api/organizations";

/// Rows in the inline preview; the panel pages through the rest.
const PREVIEW_ROWS = 5;

/// Every governance act in the org — the space-scoped ones included, since an
/// admin wants one place to see them all rather than a tour of every space.
export const GovernancePanel: React.FC<{ org: Org }> = ({ org }) => {
  const [panelOpen, setPanelOpen] = useState(false);
  const audit = useGovernanceAudit(org.org_id, undefined, PREVIEW_ROWS);

  return (
    <>
      <section className="flex flex-col">
        <SectionRule
          label="Governance"
          action={
            audit.entries.length > 0
              ? { label: "Show all", onClick: () => setPanelOpen(true) }
              : undefined
          }
        />
        <div className="flex flex-col gap-2">
          <span className="text-fg-muted-regular-small">
            Every organization, membership and space change, including those
            made by administrators.
          </span>
          {audit.available === null ? (
            <LoadingState label="Loading events…" />
          ) : (
            <GovernanceAuditList
              entries={audit.entries}
              names={audit.names}
              showSpace
            />
          )}
        </div>
      </section>

      <GovernanceAuditPanel
        open={panelOpen}
        onClose={() => setPanelOpen(false)}
        orgId={org.org_id}
        title={`Governance · ${org.name}`}
        showSpace
      />
    </>
  );
};
